export { default } from './P'
